// extracted by mini-css-extract-plugin
export default {"controls_container":"WorkQueuesControls_controls_container__Gl7Sr","loader_container":"WorkQueuesControls_loader_container__AWZgO"};